<template>
    <div class="" >
            <div v-if="unread" class="rounded-full bg-red-500 animate-pulse" :style="sizeObject" >
                &nbsp;
            </div>
    </div>
</template>
<script>
export default{
    props: {
        unread : {
            type : Boolean,
            requierd: true,
        },
        size: {
            type: Number, 
            default: 20,
        }
    },
    data(){
        return {

        }
    },
    computed: {
        sizeObject() {
            return {
                width: this.size + 'px',
                height: this.size + 'px',
            };
        }
    }
}
</script>